<template>
  <div class="wrapper">
    <van-cell-group>
    <div class="question">{{num}}.
      在您临床上最近碰到的<span>10个确诊食物过敏</span>的患儿，<span>【治疗过程中】</span>需要
      <span>替代配方</span>时，大约有多少个采用了<span>氨基酸配方</span>替代喂养？（单选）</div>
    <div class="options">
      <van-radio-group v-model="answerObj.value" direction="horizontal"  @change="changeRadio">
        <van-radio v-for="item in options" :key="item" :name="item" style="margin-right:30px;">{{ item }}</van-radio>
      </van-radio-group>
    </div>
    </van-cell-group>
  </div>
</template>
<script>
export default {
  props: {
    num: {}
  },
  data() {
    return {
      result: '',
      options: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      confirm: '',
      form: {
        total: 0
      },
      answerObj: {
        sort: '3',
        title: '在临床上，如果有100个确诊的食物过敏患儿，您实际推荐以下各类型特医配方食品“用于治疗目的”的比例分别是多少？',
        remark: '',
        value: ''
      },
    };
  },
  created() {
    
  },
  methods: {
    changeRadio(e) {
      this.$emit('getAnswerThird', e)
    },
    handleInput(e, index) {
      if (index == 0) {
        this.$emit('getThirdPercent', e === '' ? 0 : Number(e))
      }
      this.$emit('getAnswerThird', this.answerObj.answers)
      let total = 0;
      this.answerObj.answers.map(item => {
        if (item.sort !== 4) {
          total += item.percent === '' ? 0 : Number(item.percent);
        }
      })
      this.form.total = total;
      this.confirm = ''
    },
  },
};
</script>

<style lang="less" scoped>
  .question {
    span {
        color: purple;
        font-weight: bold;
    }
  }
  .options {
      padding-top: 10px;
      font-size: 14px;
      margin: 0 10px;
      border-bottom: 1px solid #eee;
      .tips {
        color: red;
        font-size: 14px;
        text-align: right;
      }
      &:last-child {
        border-bottom: 1px solid #fff;
      }
  }
  .operation {
      margin: 0 10px;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      .total {
          line-height: 28px;
      }
      .tips {
        color: red;
        text-align: right;
        line-height: 28px;
      }
  }
</style>
